let setting = [
   {
      path: "/updatePassword",
      name: "updatePassword",
      component: () => import("@/views/setting/updatePassword.vue"),
      meta: {
         title: "修改密码",
      },
   },
]


export default setting